import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    darkmode: !(localStorage.getItem("darkmode") == "false"),
    status: localStorage.getItem("status") || "",
    token: localStorage.getItem("token") || "",
    companyFantasyName: localStorage.getItem("companyFantasyName") || {},
    userId: localStorage.getItem("userId") || {},
    companyId: localStorage.getItem("companyId") || {},
    userName: localStorage.getItem("userName") || {},
    userDisplayName: localStorage.getItem("userDisplayName") || {},
    companyTheme: localStorage.getItem("companyTheme") || "",
    accessTripPlan: localStorage.getItem("accessTripPlan") == "true" || false,
    accessVehicles: localStorage.getItem("accessVehicles") == "true" || false,
    adminRms: localStorage.getItem("adminRms") == "true" || false,
    administrator: localStorage.getItem("administrator") == "true" || false,
    checklist: localStorage.getItem("checklist") == "true" || false,
    fuelSupply: localStorage.getItem("fuelSupply") == "true" || false,
    revision: localStorage.getItem("revision") == "true" || false,
    tracking: localStorage.getItem("tracking") == "true" || false,
    criadorFormularios:
      localStorage.getItem("criadorFormularios") == "true" || false,
    checklistTypingForm:
      localStorage.getItem("checklistTypingForm") == "true" || false,
    checklistPendenciesView:
      localStorage.getItem("checklistPendenciesView") == "true" || false,
    companyShipper: localStorage.getItem("companyShipper") == "true" || false,
    cargoKanbamAvaliable:
      localStorage.getItem("cargoKanbamAvaliable") == "true" || false,
    cargoExpensesAvaliable:
      localStorage.getItem("cargoExpensesAvaliable") == "true" || false,
    accessCompany: localStorage.getItem("accessCompany") == "true" || false,
    accessLoads: localStorage.getItem("accessLoads") == "true" || false,
    accessNonAttendanceReason:
      localStorage.getItem("accessNonAttendanceReason") == "true" || false,
    accessProfile: localStorage.getItem("accessProfile") == "true" || false,
    accessTypeOccurrence:
      localStorage.getItem("accessTypeOccurrence") == "true" || false,
    accessTypeOccurrenceExpense:
      localStorage.getItem("accessTypeOccurrenceExpense") == "true" || false,
    accessTypeVehicle:
      localStorage.getItem("accessTypeVehicle") == "true" || false,
    accessUser: localStorage.getItem("accessUser") == "true" || false,
    canDeleteForm: localStorage.getItem("canDeleteForm") == "true" || false,
    canEditForm: localStorage.getItem("canEditForm") == "true" || false,
    canReopenForm: localStorage.getItem("canReopenForm") == "true" || false,
    accessJustOwnChecklists:
      localStorage.getItem("accessJustOwnChecklists") == "true" || false,
    canImportUser: localStorage.getItem("canImportUser") == "true" || false,
    workflow: localStorage.getItem("workflow") == "true" || false,
    mapEngine: localStorage.getItem("mapEngine") || 0,
    googleApiKey: localStorage.getItem("googleApiKey") || "",
    imageQuality: localStorage.getItem("imageQuality") || 0,
    compressionLevel: localStorage.getItem("compressionLevel") || 40,
    allowVideo: localStorage.getItem("allowVideo") || 0,
    allowDocuments: localStorage.getItem("allowDocuments") || 0,
    allowOcr: localStorage.getItem("allowOcr") || 0,
    accessGasStation:
      localStorage.getItem("accessGasStation") == "true" || false,
    accessFuelConsumptionTarget:
      localStorage.getItem("accessFuelConsumptionTarget") == "true" || false,
    accessFuelStock: localStorage.getItem("accessFuelStock") == "true" || false,
    accessFuelSupply:
      localStorage.getItem("accessFuelSupply") == "true" || false,
    accessFuelSupplyDashboard:
      localStorage.getItem("accessFuelSupplyDashboard") == "true" || false,
    accessFuelSupplyDashboardHorimeter:
      localStorage.getItem("accessFuelSupplyDashboardHorimeter") == "true" ||
      false,
    accessRevision: localStorage.getItem("accessRevision") == "true" || false,
    accessRevisionDashboard:
      localStorage.getItem("accessRevisionDashboard") == "true" || false,
    accessRevisionIndex:
      localStorage.getItem("accessRevisionIndex") == "true" || false,
    accessRevisionModelCrud:
      localStorage.getItem("accessRevisionModelCrud") == "true" || false,

    urlTracking: process.env.VUE_APP_URL_TRACKING,
    urlChecklist: process.env.VUE_APP_URL_CHECKLIST,
    urlScheduler: process.env.VUE_APP_URL_SCHEDULER,
    urlWorkflow: process.env.VUE_APP_URL_WORKFLOW,
    urlVehicle: process.env.VUE_APP_URL_VEHICLE,
    urlDynamicSearches: process.env.VUE_APP_URL_DYNAMIC_SEARCHES,
    formFuelSupplyId: parseInt(process.env.VUE_APP_FORM_FUEL_SUPPLY_ID),
    formFuelEntraceId: parseInt(process.env.VUE_APP_FORM_FUEL_ENTRACE_ID),
    formVehicleRevisionEntryId: parseInt(
      process.env.VUE_APP_FORM_VEHICLE_REVISION_ENTRY_ID
    ),
    formVehicleRevisionExitId: parseInt(
      process.env.VUE_APP_FORM_VEHICLE_REVISION_EXIT_ID
    )
  },
  mutations: {
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, { token, user }) {
      state.status = "success";
      state.token = token;
      state.companyFantasyName = user.empresaNomeFantasia;
      state.userId = user.id;
      state.companyId = user.empresaId;
      state.userName = user.nomeAcesso;
      state.userDisplayName = user.nomeApresentacao;
      state.companyTheme = user.companyTheme;
      state.accessTripPlan = user.accessTripPlan;
      state.accessVehicles = user.accessVehicles;
      state.adminRms = user.adminRms;
      state.administrator = user.administrator;
      state.checklist = user.checklist;
      state.fuelSupply = user.fuelSupply;
      state.revision = user.revision;
      state.tracking = user.tracking;
      state.criadorFormularios = user.checklistFormCreator;
      state.checklistTypingForm = user.checklistTypingForm;
      state.checklistPendenciesView = user.checklistPendenciesView;
      state.companyShipper = user.empresaEmbarcadora;
      state.cargoExpensesAvaliable = user.cargoExpensesAvaliable;
      state.cargoKanbamAvaliable = user.cargoKanbamAvaliable;
      state.accessCompany = user.accessCompany;
      state.accessLoads = user.accessLoads;
      state.accessNonAttendanceReason = user.accessNonAttendanceReason;
      state.accessTypeOccurrence = user.accessTypeOccurrence;
      state.accessTypeOccurrenceExpense = user.accessTypeOccurrenceExpense;
      state.accessTypeVehicle = user.accessTypeVehicle;
      state.accessUser = user.accessUser;
      state.accessProfile = user.accessProfile;
      state.canDeleteForm = user.canDeleteForm;
      state.canEditForm = user.canEditForm;
      state.canReopenForm = user.canReopenForm;
      state.accessJustOwnChecklists = user.accessJustOwnChecklists;
      state.canImportUser = user.canImportUser;
      state.workflow = user.workflow;
      state.mapEngine = user.mapEngine;
      state.googleApiKey = user.googleApiKey;
      state.imageQuality = user.imageQuality;
      state.compressionLevel = user.compressionLevel;
      state.allowVideo = user.allowVideo;
      state.allowDocuments = user.allowDocuments;
      state.allowOcr = user.allowOcr;
      state.accessGasStation = user.accessGasStation;
      state.accessFuelConsumptionTarget = user.accessFuelConsumptionTarget;
      state.accessFuelStock = user.accessFuelStock;
      state.accessFuelSupply = user.accessFuelSupply;
      state.accessFuelSupplyDashboard = user.accessFuelSupplyDashboard;
      state.accessFuelSupplyDashboardHorimeter =
        user.accessFuelSupplyDashboardHorimeter;
      state.accessRevision = user.accessRevision;
      state.accessRevisionDashboard = user.accessRevisionDashboard;
      state.accessRevisionIndex = user.accessRevisionIndex;
      state.accessRevisionModelCrud = user.accessRevisionModelCrud;

      Vue.prototype.$api = axios.create({
        baseURL: this.state.urlTracking,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + state.token
        }
      });

      Vue.prototype.$apiNoAuthenticated = axios.create({
        baseURL: this.state.urlScheduler
      });

      Vue.prototype.$apiChecklist = axios.create({
        baseURL: this.state.urlChecklist,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + state.token
        }
      });

      Vue.prototype.$apiWorkflow = axios.create({
        baseURL: this.state.urlWorkflow,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + state.token
        }
      });

      Vue.prototype.$apiScheduler = axios.create({
        baseURL: this.state.urlScheduler,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + state.token
        }
      });

      Vue.prototype.$apiVehicle = axios.create({
        baseURL: this.state.urlVehicle,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + state.token
        }
      });

      Vue.prototype.$apiDynamicSearches = axios.create({
        baseURL: this.state.urlDynamicSearches,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + state.token
        }
      });

      this.dispatch("set_companyLayout");
    },
    auth_error(state) {
      state.status = "error";
    },
    clear_local_storage() {
      localStorage.removeItem("token");
      localStorage.removeItem("companyFantasyName");
      localStorage.removeItem("userId");
      localStorage.removeItem("companyId");
      localStorage.removeItem("userName");
      localStorage.removeItem("userDisplayName");
      localStorage.removeItem("companyTheme");
      localStorage.removeItem("accessVehicles");
      localStorage.removeItem("accessTripPlan");
      localStorage.removeItem("adminRms");
      localStorage.removeItem("administrator");
      localStorage.removeItem("checklist");
      localStorage.removeItem("fuelSupply");
      localStorage.removeItem("revision");
      localStorage.removeItem("tracking");
      localStorage.removeItem("criadorFormularios");
      localStorage.removeItem("checklistTypingForm");
      localStorage.removeItem("checklistPendenciesView");
      localStorage.removeItem("companyShipper");
      localStorage.removeItem("cargoExpensesAvaliable");
      localStorage.removeItem("cargoKanbamAvaliable");
      localStorage.removeItem("accessCompany");
      localStorage.removeItem("accessLoads");
      localStorage.removeItem("accessNonAttendanceReason");
      localStorage.removeItem("accessProfile");
      localStorage.removeItem("accessTypeOccurrence");
      localStorage.removeItem("accessTypeOccurrenceExpense");
      localStorage.removeItem("accessTypeVehicle");
      localStorage.removeItem("accessUser");
      localStorage.removeItem("canEditForm");
      localStorage.removeItem("canReopenForm");
      localStorage.removeItem("canDeleteForm");
      localStorage.removeItem("accessJustOwnChecklists");
      localStorage.removeItem("canImportUser");
      localStorage.removeItem("workflow");
      localStorage.removeItem("mapEngine");
      localStorage.removeItem("googleApiKey");
      localStorage.removeItem("imageQuality");
      localStorage.removeItem("compressionLevel");
      localStorage.removeItem("allowVideo");
      localStorage.removeItem("allowDocuments");
      localStorage.removeItem("allowOcr");
      localStorage.removeItem("accessGasStation");
      localStorage.removeItem("accessFuelConsumptionTarget");
      localStorage.removeItem("accessFuelStock");
      localStorage.removeItem("accessFuelSupply");
      localStorage.removeItem("accessFuelSupplyDashboard");
      localStorage.removeItem("accessFuelSupplyDashboardHorimeter");
      localStorage.removeItem("accessRevision");
      localStorage.removeItem("accessRevisionDashboard");
      localStorage.removeItem("accessRevisionIndex");
      localStorage.removeItem("accessRevisionModelCrud");
    },
    set_local_storage(state, { token, user }) {
      localStorage.setItem("token", token);
      localStorage.setItem("companyFantasyName", user.empresaNomeFantasia);
      localStorage.setItem("userId", user.id);
      localStorage.setItem("companyId", user.empresaId);
      localStorage.setItem("userName", user.nomeAcesso);
      localStorage.setItem("userDisplayName", user.nomeApresentacao);
      localStorage.setItem("companyTheme", user.companyTheme);
      localStorage.setItem("accessTripPlan", user.accessTripPlan);
      localStorage.setItem("accessVehicles", user.accessVehicles);
      localStorage.setItem("adminRms", user.adminRms);
      localStorage.setItem("administrator", user.administrator);
      localStorage.setItem("checklist", user.checklist);
      localStorage.setItem("fuelSupply", user.fuelSupply);
      localStorage.setItem("revision", user.revision);
      localStorage.setItem("tracking", user.tracking);
      localStorage.setItem("criadorFormularios", user.checklistFormCreator);
      localStorage.setItem("checklistTypingForm", user.checklistTypingForm);
      localStorage.setItem(
        "checklistPendenciesView",
        user.checklistPendenciesView
      );
      localStorage.setItem("companyShipper", user.empresaEmbarcadora);
      localStorage.setItem("cargoKanbamAvaliable", user.cargoKanbamAvaliable);
      localStorage.setItem(
        "cargoExpensesAvaliable",
        user.cargoExpensesAvaliable
      );
      localStorage.setItem("accessCompany", user.accessCompany);
      localStorage.setItem("accessLoads", user.accessLoads);
      localStorage.setItem(
        "accessNonAttendanceReason",
        user.accessNonAttendanceReason
      );
      localStorage.setItem("accessProfile", user.accessProfile);
      localStorage.setItem("accessTypeOccurrence", user.accessTypeOccurrence);
      localStorage.setItem(
        "accessTypeOccurrenceExpense",
        user.accessTypeOccurrenceExpense
      );
      localStorage.setItem("accessTypeVehicle", user.accessTypeVehicle);
      localStorage.setItem("accessUser", user.accessUser);
      localStorage.setItem("canDeleteForm", user.canDeleteForm);
      localStorage.setItem("canEditForm", user.canEditForm);
      localStorage.setItem("canReopenForm", user.canReopenForm);
      localStorage.setItem(
        "accessJustOwnChecklists",
        user.accessJustOwnChecklists
      );
      localStorage.setItem("canImportUser", user.canImportUser);
      localStorage.setItem("workflow", user.workflow);
      localStorage.setItem("mapEngine", user.mapEngine);
      localStorage.setItem("googleApiKey", user.googleApiKey);
      localStorage.setItem("imageQuality", user.imageQuality);
      localStorage.setItem("compressionLevel", user.compressionLevel);
      localStorage.setItem("allowVideo", user.allowVideo);
      localStorage.setItem("allowDocuments", user.allowDocuments);
      localStorage.setItem("allowOcr", user.allowOcr);
      localStorage.setItem("accessGasStation", user.accessGasStation);
      localStorage.setItem(
        "accessFuelConsumptionTarget",
        user.accessFuelConsumptionTarget
      );
      localStorage.setItem("accessFuelStock", user.accessFuelStock);
      localStorage.setItem("accessFuelSupply", user.accessFuelSupply);
      localStorage.setItem(
        "accessFuelSupplyDashboard",
        user.accessFuelSupplyDashboard
      );
      localStorage.setItem(
        "accessFuelSupplyDashboardHorimeter",
        user.accessFuelSupplyDashboardHorimeter
      );
      localStorage.setItem("accessRevision", user.accessRevision);
      localStorage.setItem(
        "accessRevisionDashboard",
        user.accessRevisionDashboard
      );
      localStorage.setItem("accessRevisionIndex", user.accessRevisionIndex);
      localStorage.setItem(
        "accessRevisionModelCrud",
        user.accessRevisionModelCrud
      );
    },
    logout(state) {
      state.status = "";
      state.token = "";
      state.companyFantasyName = "";
      state.userId = "";
      state.companyId = "";
      state.userName = "";
      state.userDisplayName = "";
      state.companyTheme = "";
      state.accessTripPlan = false;
      state.accessVehicles = false;
      state.adminRms = false;
      state.administrator = false;
      state.checklist = false;
      state.fuelSupply = false;
      state.revision = false;
      state.tracking = false;
      state.criadorFormularios = false;
      state.checklistTypingForm = false;
      state.checklistPendenciesView = false;
      state.companyShipper = false;
      state.cargoExpensesAvaliable = false;
      state.cargoKanbamAvaliable = false;
      state.accessCompany = false;
      state.accessLoads = false;
      state.accessNonAttendanceReason = false;
      state.accessProfile = false;
      state.accessTypeOccurrence = false;
      state.accessTypeOccurrenceExpense = false;
      state.accessTypeVehicle = false;
      state.accessUser = false;
      state.canDeleteForm = false;
      state.canEditForm = false;
      state.canReopenForm = false;
      state.accessJustOwnChecklists = false;
      state.canImportUser = false;
      state.workflow = false;
      state.mapEngine = 0;
      state.googleApiKey = "";
      state.imageQuality = 0;
      state.compressionLevel = 40;
      state.allowVideo = 0;
      state.allowDocuments = 0;
      state.allowOcr = 0;
      state.accessGasStation = false;
      state.accessFuelConsumptionTarget = false;
      state.accessFuelStock = false;
      state.accessFuelSupply = false;
      state.accessFuelSupplyDashboard = false;
      state.accessFuelSupplyDashboardHorimeter = false;
      state.accessRevision = false;
      state.accessRevisionDashboard = false;
      state.accessRevisionIndex = false;
      state.accessRevisionModelCrud = false;

      Vue.prototype.$api = null;

      Vue.prototype.$apiNoAuthenticated = axios.create({
        baseURL: this.state.urlScheduler
      });

      Vue.prototype.$apiChecklist = null;
      Vue.prototype.$apiWorkflow = null;
      Vue.prototype.$apiScheduler = null;
      Vue.prototype.$apiVehicle = null;
      Vue.prototype.$apiDynamicSearches = null;

      this.dispatch("reset_companyLayout");
    },
    set_darkmode(state, darkmode) {
      state.darkmode = darkmode;
    },
    set_userDisplayName(state, userName) {
      state.userDisplayName = userName;
    }
  },
  actions: {
    forgotPassword({ commit }, user) {
      return new Promise((resolve, reject) => {
        const baseUrl = this.state.urlScheduler;
        axios({
          url: baseUrl + "/v1/changePassword/EmailSend",
          data: user,
          method: "POST"
        })
          .then(resp => {
            resolve(resp);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    redefinePassword({ commit }, user) {
      return new Promise((resolve, reject) => {
        const baseUrl = this.state.urlScheduler;
        axios({
          url: baseUrl + "/v1/user/password/forgot",
          data: user,
          method: "POST"
        })
          .then(resp => {
            resolve(resp);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        const baseUrl = this.state.urlScheduler;
        commit("auth_request");
        axios({ url: baseUrl + "/v1/access/login", data: user, method: "POST" })
          .then(resp => {
            if (resp.data.isSuccess) {
              const token = resp.data.token;
              const user = resp.data.user;
              commit("set_local_storage", { token, user });

              // Add the following line:
              axios.defaults.headers.common["Authorization"] = token;
              commit("auth_success", { token, user });
            }
            resolve(resp);
          })
          .catch(err => {
            commit("auth_error");
            commit("clear_local_storage");
            reject(err);
          });
      });
    },
    loginRms({ commit }, user) {
      return new Promise((resolve, reject) => {
        const baseUrl = this.state.urlScheduler;
        commit("auth_request");
        axios({
          url: baseUrl + "/v1/access/login/rmsUser",
          data: user,
          method: "POST"
        })
          .then(resp => {
            this.dispatch("reset_companyLayout");

            const token = resp.data.token;
            const user = resp.data.user;
            commit("set_local_storage", { token, user });

            // Add the following line:
            axios.defaults.headers.common["Authorization"] = token;
            commit("auth_success", { token, user });
            resolve(resp);
          })
          .catch(err => {
            commit("auth_error");
            commit("clear_local_storage");
            reject(err);
          });
      });
    },
    loginTrackingClient({ commit }, user) {
      return new Promise((resolve, reject) => {
        const baseUrl = this.state.urlTracking;
        commit("auth_request");
        axios({
          url: baseUrl + "/v1/deliveryClient/auth",
          data: user,
          method: "POST"
        })
          .then(resp => {
            const token = resp.data.token;
            const user = resp.data.user;
            commit("set_local_storage", { token, user });

            // Add the following line:
            axios.defaults.headers.common["Authorization"] = token;
            commit("auth_success", { token, user });
            resolve(resp);
          })
          .catch(err => {
            commit("auth_error");
            commit("clear_local_storage");
            reject(err);
          });
      });
    },
    register({ commit }, user) {
      return new Promise((resolve, reject) => {
        //const baseUrl = 'https://rmsgroup.app:81';
        //const baseUrl = 'http://localhost:5000';
        const baseUrl = this.state.urlTracking; // 'http://192.168.0.101:5000';

        commit("auth_request");
        axios({ url: baseUrl + "/usuario/create", data: user, method: "POST" })
          .then(resp => {
            const token = resp.data.token;
            const user = resp.data.user;
            commit("set_local_storage", { token, user });

            // Add the following line:
            axios.defaults.headers.common["Authorization"] = token;
            commit("auth_success", { token, user });
            resolve(resp);
          })
          .catch(err => {
            commit("auth_error", err);
            commit("clear_local_storage");
            reject(err);
          });
      });
    },
    logout({ commit }) {
      return new Promise(resolve => {
        commit("logout");
        commit("clear_local_storage");
        delete axios.defaults.headers.common["Authorization"];
        resolve();
      });
    },
    darkmode({ commit }, darkmode) {
      return new Promise(resolve => {
        commit("set_darkmode", darkmode);
        localStorage.setItem("darkmode", darkmode);
        resolve();
      });
    },
    userDisplayName({ commit }, userDisplayName) {
      return new Promise(resolve => {
        commit("set_userDisplayName", userDisplayName);
        localStorage.setItem("userDisplayName", userDisplayName);
        resolve();
      });
    },
    set_companyLayout() {
      if (this.getters.companyFantasyName == "EXPRESSO GONÇALVES") {
        let docClasses = document.body.classList;
        docClasses.add("eglog-content");
      }
      if (this.getters.companyTheme == "EGLOG") {
        let docClasses = document.body.classList;
        docClasses.add("eglog-content");
      }
      if (this.getters.companyTheme == "AMAGGI") {
        let docClasses = document.body.classList;
        docClasses.add("amaggi-content");
      }
    },
    reset_companyLayout() {
      let docClasses = document.body.classList;
      docClasses.remove("eglog-content");
      docClasses.remove("amaggi-content");
    }
  },
  getters: {
    authStatus: state => state.status,
    autoRefreshTime: state => 10000,
    apiScheduler: state => this.$apiScheduler,
    companyFantasyName: state => state.companyFantasyName,
    companyTheme: state => state.companyTheme,
    userId: state => state.userId,
    companyId: state => state.companyId,
    userDisplayname: state => state.userDisplayName,
    darkmode: state => state.darkmode,
    formFuelSupplyId: state => state.formFuelSupplyId,
    formFuelEntraceId: state => state.formFuelEntraceId,
    formVehicleRevisionEntryId: state => state.formVehicleRevisionEntryId,
    formVehicleRevisionExitId: state => state.formVehicleRevisionExitId,
    hasAccessChecklist: state => state.checklist,
    hasAccessFuelSupply: state => state.fuelSupply,
    hasAccessRevision: state => state.revision,
    hasAccessTracking: state => state.tracking,
    hasAccessWorkflow: state => state.workflow,
    isLoggedIn: state => !!state.token,
    isAdminRms: state => state.adminRms,
    isAdministrator: state => state.administrator,
    isChecklistPendenciesView: state =>
      state.checklist && (state.administrator || state.checklistPendenciesView),
    isChecklistFormCreator: state =>
      state.checklist && (state.administrator || state.criadorFormularios),
    isChecklistFormFiller: state =>
      state.checklist && (state.administrator || state.checklistTypingForm),
    isChecklistFormEdit: state => state.checklist && state.canEditForm,
    isReopenForm: state => state.checklist && state.canReopenForm,
    isAccessJustOwnChecklists: state =>
      state.checklist && state.accessJustOwnChecklists,
    isChecklistFormDelete: state => state.checklist && state.canDeleteForm,
    isCompanyShipper: state => state.tracking && state.companyShipper,
    isCargoExpensesAvaliable: state =>
      state.tracking && state.cargoExpensesAvaliable,
    isCargoKanbamAvaliable: state =>
      state.tracking && state.cargoKanbamAvaliable,
    isShLog: state => state.companyId == 398,
    hasAccessCompany: state =>
      (state.checklist && state.accessCompany) ||
      (state.tracking && state.accessCompany),
    hasAccessLoads: state => state.tracking && state.accessLoads,
    hasAccessNonAttendanceReason: state =>
      state.tracking && state.accessNonAttendanceReason,
    hasAccessProfile: state =>
      (state.checklist && state.accessProfile) ||
      (state.tracking && state.accessProfile),
    accessGasStation: state => state.fuelSupply && state.accessGasStation,
    accessFuelConsumptionTarget: state =>
      state.fuelSupply && state.accessFuelConsumptionTarget,
    accessFuelStock: state => state.fuelSupply && state.accessFuelStock,
    accessFuelSupply: state => state.fuelSupply && state.accessFuelSupply,
    accessFuelSupplyDashboard: state =>
      state.fuelSupply && state.accessFuelSupplyDashboard,
    accessFuelSupplyDashboardHorimeter: state =>
      state.fuelSupply && state.accessFuelSupplyDashboardHorimeter,
    accessFuelSupplyMenu: state =>
      state.accessGasStation ||
      state.accessFuelConsumptionTarget ||
      state.accessFuelStock ||
      state.accessFuelSupply ||
      state.accessFuelSupplyDashboard ||
      state.accessFuelSupplyDashboardHorimeter,
    accessRevision: state => state.revision && state.accessRevision,
    accessRevisionDashboard: state =>
      state.revision && state.accessRevisionDashboard,
    accessRevisionIndex: state => state.revision && state.accessRevisionIndex,
    accessRevisionModelCrud: state =>
      state.revision && state.accessRevisionModelCrud,
    accessRevisionMenu: state =>
      state.accessRevision ||
      state.accessRevisionDashboard ||
      state.accessRevisionIndex ||
      state.accessRevisionModelCrud,
    accessTripPlan: state => state.accessTripPlan,
    accessVehicles: state => state.accessVehicles,
    hasAccessTypeOccurrence: state =>
      state.tracking && state.accessTypeOccurrence,
    hasAccessTypeOccurrenceExpense: state =>
      state.tracking && state.accessTypeOccurrenceExpense,
    hasAccessTypeVehicle: state => state.tracking && state.accessTypeVehicle,
    hasAccessUser: state =>
      (state.checklist && state.accessUser) ||
      (state.tracking && state.accessUser),
    importUser: state =>
      (state.checklist && state.canImportUser) ||
      (state.tracking && state.canImportUser),
    systemLogoHome: state => {
      if (state.companyFantasyName == "EXPRESSO GONÇALVES")
        return "/img/clients/eglog/logo.jpg";
      switch (state.companyTheme) {
        case "AMAGGI":
          return "/img/clients/amaggi/foto_redonda_amaggi_resized.png";
        case "EGLOG":
          return "/img/clients/eglog/logo.jpg";
        default:
          return "/img/logo_tecnologia_branco.png";
      }
    },
    systemLogoSidebar: state => {
      if (state.companyFantasyName == "EXPRESSO GONÇALVES")
        return "/img/clients/eglog/logo.jpg";
      switch (state.companyTheme) {
        case "AMAGGI":
          return "/img/clients/amaggi/sim4.0_resized.png";
        case "EGLOG":
          return "/img/clients/eglog/logo.jpg";
        default:
          return "/img/icon-vue.png";
      }
    },
    systemTile: state => {
      if (state.companyFantasyName == "EXPRESSO GONÇALVES") return "EG Log";
      switch (state.companyTheme) {
        case "AMAGGI":
          return "Sim4.0 - Amaggi";
        case "EGLOG":
          return "EG Log";
        default:
          return "RMS Group";
      }
    },
    systemTitleImage: state => {
      switch (state.companyTheme) {
        case "AMAGGI":
          return "/img/clients/amaggi/amaggi_150x14.png";
        default:
          return null;
      }
    },
    urlChecklist: state => state.urlChecklist,
    urlDynamicSearches: state => state.urlDynamicSearches,
    urlScheduler: state => state.urlScheduler,
    urlVehicle: state => state.urlVehicle,
    urlWorkflow: state => state.urlWorkflow,
    token: state => state.token,
    mapEngine: state => state.mapEngine,
    googleApiKey: state => state.googleApiKey,
    imageQuality: state => state.imageQuality,
    compressionLevel: state => state.compressionLevel,
    allowVideo: state => state.allowVideo,
    allowDocuments: state => state.allowDocuments,
    allowOcr: state => state.allowOcr,
    getUserName: state => state.userName
  }
});
